export { default } from './DefaultLocations';
export { default as reducer } from './DefaultLocations.ducks';
export { default as sagas } from './DefaultLocations.sagas';

import * as actions from './DefaultLocations.ducks';

export { actions };
